import "./faucet.scss";
import { useWeb3Context } from "../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "src/store/slices/state.interface";
import { changeApproval } from "src/store/slices/pool-thunk";
import { useEffect, useState } from "react";
import { Grid, Zoom } from "@material-ui/core";
import { IPendingTxn } from "../../store/slices/pending-txns-slice";
import { error, success, warning } from "../../store/slices/messages-slice";
import { getAddresses } from "src/constants";
import { apiPostRequest } from "src/helpers/api-request";
import { addTokenToWallet } from "src/components/Header/time-menu";
import CheckIcon from "../../assets/icons/check-circle.svg";
import { getTokenSVG } from "src/helpers";

function BuyCrypto() {
    const dispatch = useDispatch();
    const { provider, address, connect, chainID, checkWrongNetwork } = useWeb3Context();
    const addresses = getAddresses(chainID);

    const isAppLoading = useSelector<IReduxState, boolean>(state => state.app.loading);
    const usdcBalance = useSelector<IReduxState, string>(state => {
        return state.account.balances && state.account.balances.usdc;
    });
    const usdtBalance = useSelector<IReduxState, string>(state => {
        return state.account.balances && state.account.balances.usdt;
    });
    const daiBalance = useSelector<IReduxState, string>(state => {
        return state.account.balances && state.account.balances.dai;
    });

    return (
        <div className="faucet-view">
            <Zoom in={true}>
                <div className="faucet-card mb-3">
                    <iframe
                        height="625"
                        title="Transak On/Off Ramp Widget"
                        src={`https://global-stg.transak.com?apiKey=8e33f2e6-7195-45d5-8ee9-35979bffc59d&defaultCryptoCurrency=USDC&cryptoCurrencyList=USDC,USDT,DAI&network=polygon&walletAddress=${address}`}
                        frameBorder="no"
                        allowTransparency={true}
                        allowFullScreen={false}
                        style={{ display: "block", width: "100%", maxHeight: "625px", maxWidth: "500px;" }}
                    ></iframe>
                </div>
            </Zoom>
        </div>
    );
}
export default BuyCrypto;
